/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketSelectItem } from '../../models/support-ticket-select-item';

export interface UnmergeTickets$Params {
  relatedIDs?: Array<number>;
  unmergeAllTickets?: boolean;
      body?: {
'id'?: number;
}
}

export function UnmergeTickets(http: HttpClient, rootUrl: string, params?: UnmergeTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketSelectItem>> {
  const rb = new RequestBuilder(rootUrl, UnmergeTickets.PATH, 'post');
  if (params) {
    rb.query('relatedIDs', params.relatedIDs, {});
    rb.query('unmergeAllTickets', params.unmergeAllTickets, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketSelectItem>;
    })
  );
}

UnmergeTickets.PATH = '/api/Tickets/UnmergeTickets';
